import { render, staticRenderFns } from "./RightBottom.vue?vue&type=template&id=5fcbef8a&scoped=true"
import script from "./RightBottom.vue?vue&type=script&lang=js"
export * from "./RightBottom.vue?vue&type=script&lang=js"
import style0 from "./RightBottom.vue?vue&type=style&index=0&id=5fcbef8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcbef8a",
  null
  
)

export default component.exports